export enum AccountPreferences {
  Email = 0,
  Post = 1,
}
